import React from 'react';
interface StatCardProps {
  title: string;
  value: string | number;
  icon: React.ReactNode;
  change?: {
    value: string | number;
    isPositive: boolean;
  };
  color?: 'blue' | 'green' | 'yellow' | 'red' | 'purple';
}
const StatCard = ({
  title,
  value,
  icon,
  change,
  color = 'blue'
}: StatCardProps) => {
  const colorClasses = {
    blue: 'bg-primary-50 text-primary-700',
    green: 'bg-green-50 text-green-700',
    yellow: 'bg-amber-50 text-amber-700',
    red: 'bg-red-50 text-red-700',
    purple: 'bg-purple-50 text-purple-700'
  };
  return <div className="card" data-id="element-38">
      <div className="flex items-center" data-id="element-39">
        <div className={`p-3 rounded-lg ${colorClasses[color]}`} data-id="element-40">{icon}</div>
        <div className="ml-4" data-id="element-41">
          <h3 className="text-sm font-medium text-secondary-500" data-id="element-42">{title}</h3>
          <p className="text-2xl font-semibold text-secondary-900" data-id="element-43">{value}</p>
          {change && <p className={`text-xs ${change.isPositive ? 'text-green-600' : 'text-red-600'}`} data-id="element-44">
              {change.isPositive ? '↑' : '↓'} {change.value} from last month
            </p>}
        </div>
      </div>
    </div>;
};
export default StatCard;